import React, {Fragment, useEffect} from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {ContextProviderSidebar} from "./containers/sidebarContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";

import Caffee from "./components/Caffee";
import Beer from "./components/Beer";
import Wine from "./components/Wine";
import Alcohol from "./components/Alcohol";
import Bottle from "./components/Bottle";
import RefreshingDrinks from "./components/RefreshingDrinks";
import StartPage from "./components/StartPage";
import blackBackground from "./assets/pictures/old-black-background.jpg";


const AppRouter = (props) => {

    if (window.performance) {
        if (performance.navigation.type === 1) {
            window.location.href = '/home';
        }

    }


    return (
        <Router>
            <Fragment>
                <ContextProviderSidebar>
                    <Header/>
                    <div style={{
                        backgroundImage: `url(${blackBackground})`,
                        backgroundSize: "cover",
                    }} >
                        <Sidebar/>
                        <Routes>
                            <Route
                                exact
                                path="/home"
                                element={<StartPage/>}
                            />
                            <Route exact path="*"
                                element={<StartPage/>}
                            />
                            <Route exact
                                path="/kaffee"
                                element={<Caffee/>}
                            />
                            <Route exact
                                path="/erfrischendeGetranke"
                                element={<RefreshingDrinks/>}
                            />
                            <Route exact
                                path="/bier"
                                element={<Beer/>}
                            />
                            <Route
                                path="/wine"
                                element={<Wine/>}
                            />
                            <Route exact
                                path="/alkohol"
                                element={<Alcohol/>}
                            />
                            <Route exact
                                path="/flaschenpreise"
                                element={<Bottle/>}
                            />


                        </Routes>
                    </div>
                    <Footer/>
                </ContextProviderSidebar>
            </Fragment>
        </Router>
    );
};


export default (AppRouter);
